import React, { useState } from 'react';
import './App.css';
import Alert from './components/Alert';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';
// import About from './components/About';

function App() {
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type
    })
    setTimeout(() => {
      setAlert(null);
    }, 2000);
  }

  return (
    <>
      <Navbar title='Text Utils' />
      <Alert alert={alert} />
      <TextForm showAlert={showAlert} textFormHeading="Text Utils by AbdurRahman G - Word Counter, Character Counter, Listen Words etc." />
      {/* <About/> */}
    </>
  );
}

export default App;
